import React from 'react';
import { redirect, useNavigate } from 'react-router-dom';
import DashLayout from '../layouts/DashLayout';

const PrivateRoute = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'))
    const navigate = useNavigate()

    let isAuthenticated = (user.role === "ADMIN" || user.role == "STUDENT") && (user.userName)

    if (!isAuthenticated)
        navigate("/login")


    return <DashLayout>{children}</DashLayout>
}

export default PrivateRoute;
